import { render, staticRenderFns } from "./explainer-initial-message.vue?vue&type=template&id=03f04c8a&scoped=true&"
import script from "./explainer-initial-message.vue?vue&type=script&lang=js&"
export * from "./explainer-initial-message.vue?vue&type=script&lang=js&"
import style0 from "./explainer-initial-message.vue?vue&type=style&index=0&id=03f04c8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f04c8a",
  null
  
)

export default component.exports